module.exports = __webpack_public_path__ + "img/billingCenter.9b588bb4.png";